export default __webpack_public_path__ + "static/media/icn-bulb.aa98e7eb.svg";